<section>
  <onyx-information-heading>
    {{ 'labels.details' | translate }}
  </onyx-information-heading>

  <onyx-information-list>
    @let driverData = driver().driverData;
    <onyx-information-row label="labels.peselNumber" [size]="size()">
      {{ driverData.peselNumber ?? '-' }}
    </onyx-information-row>

    <onyx-information-row label="labels.birthDate" [size]="size()">
      {{ driverData.birthDate! | onyxDate: 'date-dot' }}
    </onyx-information-row>

    <onyx-information-row label="labels.privatePhone" [size]="size()">
      {{ driverData.privatePhone! | onyxPhone }}

      <div class="actions">
        <onyx-icon-button
          variant="transparent"
          color="gray"
          [size]="24"
          icon="copy-filled"
          (click)="copyPhone(driverData.privatePhone!)"
        ></onyx-icon-button>
      </div>
    </onyx-information-row>

    <onyx-information-row label="labels.nationality" [size]="size()">
      <app-country-cell
        [countryCode]="driverData.nationality"
      ></app-country-cell>
    </onyx-information-row>

    <onyx-information-row label="labels.homeAddress" [size]="size()">
      <onyx-address
        [address]="driverData.homeAddress"
        format="full"
        [showFlag]="false"
      ></onyx-address>
    </onyx-information-row>

    @if (driver().telematics; as telematics) {
      <onyx-information-row label="labels.telematics" [size]="size()">
        {{
          `${DictionaryCode.TELEMATICS_PROVIDER}.${telematics.provider}`
            | translate
        }}

        <span class="f-muted">· {{ telematics.driverId }}</span>
      </onyx-information-row>
    }
  </onyx-information-list>
</section>

<section>
  <onyx-information-heading>
    {{ 'labels.skills' | translate }}
  </onyx-information-heading>

  <onyx-information-list>
    @let skills = driver().skills;
    <onyx-information-row label="labels.languages" [size]="size()">
      <app-string-cell
        [value]="skills.languages"
        [dictionaryCode]="DictionaryCode.LANGUAGE"
      ></app-string-cell>
    </onyx-information-row>

    <onyx-information-row label="labels.driverTechnicalSkills" [size]="size()">
      <app-string-cell
        [value]="skills.technicalSkills"
        [dictionaryCode]="DictionaryCode.DRIVER_TECHNICAL_SKILL"
        [wrap]="true"
      ></app-string-cell>
    </onyx-information-row>

    <onyx-information-row label="labels.semiTrailers" [size]="size()">
      <app-string-cell
        [value]="skills.semiTrailers"
        [dictionaryCode]="DictionaryCode.VEHICLE_TYPE"
        [wrap]="true"
      ></app-string-cell>
    </onyx-information-row>

    <onyx-information-row label="labels.driverExperienceLevel" [size]="size()">
      <onyx-icon name="rating-outlined" [size]="12"></onyx-icon>

      <app-string-cell
        [value]="skills.experienceLevel"
        [dictionaryCode]="DictionaryCode.DRIVER_EXPERIENCE_LEVEL"
      ></app-string-cell>
    </onyx-information-row>
  </onyx-information-list>
</section>

<section>
  <onyx-information-heading>
    {{ 'forms.countriesWhitelist.heading' | translate }}
  </onyx-information-heading>

  <onyx-information-row label="forms.countriesWhitelist.group" [size]="size()">
    <app-allowed-countries
      [allowedCountries]="driver().countries"
    ></app-allowed-countries>
  </onyx-information-row>
</section>
